import { contactData } from '@/mocks/homeData';

export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">{contactData.title}</h2>
          <p className="text-sm text-foreground-500 mt-2">{contactData.subtitle}</p>
        </div>

        <div className="max-w-[520px] mx-auto bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="space-y-5">
            <div className="flex items-center gap-4 p-4 bg-background-100 rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-lg flex-shrink-0">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400">电子邮箱</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.email}</div>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 bg-background-100 rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-lg flex-shrink-0">
                <i className="ri-wechat-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400">微信公众号</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
              </div>
            </div>

            <div className="flex items-center gap-4 p-4 bg-background-100 rounded-xl">
              <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 text-secondary-600 rounded-lg flex-shrink-0">
                <i className="ri-qq-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-400">QQ 群号</div>
                <div className="text-sm font-medium text-foreground-800">{contactData.qq}</div>
              </div>
            </div>
          </div>

          <p className="text-xs text-foreground-400 mt-6 text-center leading-relaxed">
            欢迎提供建议、反馈问题或洽谈合作，我们将在 24 小时内回复。
          </p>
        </div>
      </div>
    </section>
  );
}